let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bs8sn")).then(() => parcelRequire('47EfI'));